module.exports = __webpack_public_path__ + "img/account--icon.62fd5653.svg";